// extracted by mini-css-extract-plugin
export default {"body":"Transfer_body__WgnNy","background":"Transfer_background__JZoz3","icon":"Transfer_icon__7ReLn","copied":"Transfer_copied__eNrcl","fade":"Transfer_fade__D7eJh"};